import { copyObject } from '@/core/shared'

export function mergeData (itemData, sourceItemData) {
	var mergeResult = copyObject(itemData, true)
	_.each(sourceItemData, function (value, key) {
		if (_.isUndefined(mergeResult[key])) {
			mergeResult[key] = value
		}
		if (value === true && mergeResult[key] === false) {
			mergeResult[key] = true
		}
		if (value && !mergeResult[key]) {
			mergeResult[key] = value
		}
		if (value && value.hasOwnProperty('val')) {
			if (value.val && !mergeResult[key].val) {
				mergeResult[key] = value
			}
		}
		if (Array.isArray(mergeResult[key])) {
			if (Array.isArray(value) && mergeResult[key].length !== 0) {
				mergeResult[key] = value
			}
		}
	})
	return mergeResult
}

export function mergeDataSLSN (dataItemTo, dataItemFrom, itemStructure, langs, unsavedData, resData) {
	for (const attr in dataItemFrom) {
		if (!_.isUndefined(dataItemTo[attr]) && !_.isUndefined(dataItemFrom[attr])) {
			if (itemStructure[attr]) {
				// SL
				if (itemStructure[attr].type === 'SL') {
					if (_.isUndefined(unsavedData[attr])) {
						unsavedData[attr] = {}
					}
					for (const key in langs) {
						if (_.isUndefined(dataItemTo[attr][key]) && dataItemFrom[attr].hasOwnProperty(key)) {
							unsavedData[attr][key] = dataItemFrom[attr][key]
						} else {
							unsavedData[attr][key] = dataItemTo[attr][key]
						}

						if (unsavedData[attr][key] === dataItemTo[attr][key]) {
							delete unsavedData[attr][key]
						} else {
							resData[attr][key] = unsavedData[attr][key]
						}
					}

					if (unsavedData[attr] && $.isEmptyObject(unsavedData[attr])) {
						delete unsavedData[attr]
					}
				}
				// NM
				if (itemStructure[attr].type === 'NM') {
					if (dataItemFrom[attr]) {
						if (dataItemTo[attr].val === null) {
							unsavedData[attr] = dataItemFrom[attr];
							resData[attr] = dataItemFrom[attr];
						}
					}
				}
				// S N multiple
				if ((itemStructure[attr].type === 'S' || itemStructure[attr].type === 'N') && itemStructure[attr].multiple) {
					let arr = []
					dataItemFrom[attr].forEach(value => {
						if (!dataItemTo[attr].includes(value)) {
							arr.push(value)
						}
					})

					if (arr.length) {
						unsavedData[attr] = dataItemTo[attr]
						unsavedData[attr] = unsavedData[attr].concat(arr)
						resData[attr] = unsavedData[attr]
					}
				}
			}
		}
		if (_.isUndefined(dataItemTo[attr]) && !_.isUndefined(dataItemFrom[attr])) {
			unsavedData[attr] = dataItemFrom[attr]
		}
	}
}

export function mergeDataForStateRestoring (itemData, sourceItemData, config) {
	var mergeResult = copyObject(itemData, true)
	_.each(sourceItemData, function (value, key) {
		if (_.isUndefined(mergeResult[key])) {
			mergeResult[key] = value
		} else {
			if (config[key]['multiple']) {
				mergeMultipleAttributesData(mergeResult, key, value)
			} else if (config[key]['type'] === 'SL') {
				mergeSimpleAttributesData(mergeResult[key], value, config[key]['type'])
			}
		}
	})
	return mergeResult
}

function mergeMultipleAttributesData (targetAttribute, keyAttribute, sourceAttribute) {
	_.each(sourceAttribute, function (value, index) {
		if (_.isUndefined(targetAttribute[keyAttribute])) {
			targetAttribute[keyAttribute] = value
		} else {
			if (targetAttribute[keyAttribute] == null) {
				delete targetAttribute[keyAttribute]
			}
		}
		return true
	})
}

function mergeSimpleAttributesData (targetAttribute, sourceAttribute, attributeType) {
	if (attributeType === 'SL') {
		_.each(sourceAttribute, function (value, lang) {
			if (_.isUndefined(targetAttribute[lang])) {
				targetAttribute[lang] = value
			} else {
				if (targetAttribute[lang] == null) {
					delete targetAttribute[lang]
				}
			}
			return true;
		});
	}
}
